"use strict";

/*
 * manager info widget for mainmenu
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var options = {
      $el: null
    };
    this.init = function () {
      options.$el = $('#manager-widget');
      var timer;
      options.$el.on("mouseover", function () {
        $.b2b.MainMenuWidgets.open("#manager-widget");
      }).on("mouseleave", function () {
        $.b2b.MainMenuWidgets.closeWidget();
      });
    };
  };

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  $(document).ready(function () {
    instance.init();
  });
})(jQuery);